import { createStore } from 'vuex'
import { authApi } from '@/api';
import { getCookie } from "@/utils/utils";

export default createStore({
  state: {
    userInfo: null,
    pageKey: [],
    pageTitle: "",
    loadingShow: false,
    hideHeader: false,
  },
  getters: {
    userInfo: (state) => state.userInfo,
    pageKey: (state) => state.pageKey,
    pageTitle: (state) => state.pageTitle,
    loadingShow: (state) => state.loadingShow,
    hideHeader: (state) => state.hideHeader,
  },
  mutations: {
    setUserInfo (state, data) {
      state.userInfo = data;
      if (data) {
        sessionStorage.setItem('hasLogin', '1');
      } else {
        sessionStorage.setItem('hasLogin', '0');
      }
    },
    setPageKey (state, data) {
      state.pageKey = data;
    },
    setPageTitle (state, data) {
      state.pageTitle = data;
    },
    setLoading (state, data) {
      state.loadingShow = data;
    },
    // hideHeader
    setHideHeader (state, data) {
      state.hideHeader = data;
    }
  },
  actions: {
    async setUserInfo ({ commit }) {
      await authApi.getUserInfo().then(res => {
        commit("setUserInfo", res.data);
      }).catch(() => {
        commit("setUserInfo", null);
      });
    },
    setUserInfoNull ({ commit }) {
      commit("setUserInfo", null);
    },
    setPageKey ({ commit }, data) {
      commit("setPageKey", data);
    },
    setPageTitle ({ commit }, data) {
      commit("setPageTitle", data);
    },
    setLoading ({ commit }, data) {
      commit("setLoading", data);
    },
    setHideHeader ({ commit }, data) {
      commit("setHideHeader", data);
    }
  },
  modules: {
  }
})
